module.exports = __webpack_public_path__ + "static/media/sidenLogo.d8611f62.svg";